import React from "react";
import { Helmet } from "react-helmet-async";

const BASE_URL = "https://comfort-trip.com";

const SEO = ({
  title = "Comfort Trip | Personal Driver & Chauffeur Service",
  description = "Book professional personal drivers with Comfort Trip for safe, reliable and comfortable transportation.",
  canonical = "/",
  image = "/images/comfort-trip-logo.jpg",
  noindex = false,
  schema = null,
}) => {
  const canonicalUrl = canonical.startsWith("http")
    ? canonical
    : `${BASE_URL}${canonical}`;

  const imageUrl = image.startsWith("http")
    ? image
    : `${BASE_URL}${image}`;

  return (
    <Helmet>
      <html lang="en" />

      <title>{title}</title>

      <meta name="description" content={description} />

      <link rel="canonical" href={canonicalUrl} />

      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow"}
      />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Comfort Trip" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />

      {/* X / Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {/* Structured data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;